import React, { FC } from 'react';
import classNames from 'classnames';

import Button from '../Button';

import css from './style.module.scss';

interface IProps {
  isInvalid?: boolean;
  isDisabled?: boolean;
  className?: boolean;
  isClearable?: boolean;
  icon?: string;
  borderRadius?: '20';
  onReset?: () => void;
  [restProps: string]: any;
}

const Input: FC<IProps> = ({
  isInvalid,
  isDisabled,
  className,
  borderRadius,
  isClearable,
  onReset,
  ...restProps
}) => (
  <div style={css.inputWrapper}>
    <input
      className={classNames(
        css.input,
        {
          [css.isDisabled]: isDisabled,
          [css.isInvalid]: isInvalid,
          [css[`input_borderRadius_${borderRadius}`]]: borderRadius,
        },
        className,
      )}
      disabled={isDisabled}
      {...restProps}
    />
    {isClearable ? (
      <div className={css.input__clearButton}>
        <Button onClick={onReset} iconSize="24" icon="24--close" variant="icon" />
      </div>
    ) : null}
  </div>
);

export default Input;
